class VersionSwitcher {
    constructor() {
        this.versionSwitcher = document.querySelector('.document-version-switcher');
    }

    init() {
        if (this.versionSwitcher) {
            this.bindEvents();
        }
    }

    bindEvents() {
        const urlParams = new URL(document.location.toString()).searchParams;

        if (urlParams.has("show-version")) {
            this.versionSwitcher.value = urlParams.get("show-version");
        }

        this.versionSwitcher.addEventListener('change', function(evt) {
           const versionId =  evt.srcElement.value || null;
           document.location.href = document.location.protocol + '//' + document.location.host + document.location.pathname + (versionId !== null ? '?show-version=' + versionId : "");
        });
    }
}

export default new VersionSwitcher();